module.exports = __webpack_public_path__ + "assets/img/eternia-solar-services-logo-small.f7349e01.png";